/* biome-ignore-all lint/suspicious/noExplicitAny: API query params conversion */
import type { Response, CollectionResponse, PageQueryParams } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface AiWordDataExample {
  sentence: string
  meaning: string
}

export interface AiWordData {
  word?: string
  part_of_speech?: string
  ipa?: string
  meaning?: string
  definition?: string
  examples?: AiWordDataExample[]
}

export type AiWordStatus = "pending_review" | "approved" | "rejected"

export interface AiWordItem {
  id: number
  word: string
  slug: string
  data: AiWordData
  search_count: number
  add_count: number
  status: AiWordStatus
  created_at: string
  updated_at: string
}

export interface AiWordSearchParams extends PageQueryParams {
  search?: string
  status?: string
  sort_by?: string
  sort_order?: "ASC" | "DESC"
}

export interface AiWordApiParams {
  page: number
  limit: number
  search?: string
  status?: string
  sort_by?: string
  sort_order?: "ASC" | "DESC"
}

export const aiWordService = {
  list(params: AiWordApiParams) {
    return HttpRequest.get("v1/ai-words", {
      searchParams: params as any,
    }).json<CollectionResponse<AiWordItem>>()
  },

  detail(id: number) {
    return HttpRequest.get(`v1/ai-words/${id}`).json<Response<AiWordItem>>()
  },

  delete(id: number) {
    return HttpRequest.delete(`v1/ai-words/${id}`).json<Response>()
  },
}
